/* Judge.me photo rescue v4 (tranquira-sculpt)
   v4: the wrapping .jdgm-rev__pic-link keeps a stale `jdgm--loading` class
   (Judge.me styles it as a circular spinner) because Judge.me's own lazyload
   never runs here. Clear it when the image is ready. Also add
   referrerpolicy=no-referrer so AliExpress CDN photos aren't hotlink-blocked. */
(function () {
  'use strict';

  function hideThumb(el) {
    var wrap = el.closest('.jdgm-rev__pic') || el.parentElement || el;
    wrap.style.display = 'none';
  }

  function reveal(img) {
    img.classList.remove('jdgm--lazyload', 'lazyload');
    img.classList.add('jdgm--loaded', 'lazyloaded');
    img.style.opacity = '1';
    img.style.visibility = 'visible';
    var link = img.closest('.jdgm-rev__pic-link');
    if (link) {
      link.classList.remove('jdgm--loading');
      link.classList.add('jdgm--loaded');
    }
  }

  function rescueImages() {
    document.querySelectorAll('.jdgm-rev__pic-img').forEach(function (img) {
      if (img.dataset.tqRescued2) return;
      img.dataset.tqRescued2 = '1';
      img.referrerPolicy = 'no-referrer';
      var real = img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
      img.addEventListener('error', function () { hideThumb(img); }, { once: true });
      img.addEventListener('load', function () { reveal(img); }, { once: true });
      if (real && img.getAttribute('src') !== real) {
        img.src = real;
      } else if (!img.getAttribute('src') && !real) {
        hideThumb(img);
        return;
      }
      if (img.complete && img.naturalWidth > 0) reveal(img);
    });
  }

  function openLightbox(src, alt) {
    var o = document.createElement('div');
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.style.cssText = 'position:fixed;inset:0;z-index:9999;display:grid;place-items:center;padding:4vmin;background:rgb(var(--c-bg) / 0.94);cursor:zoom-out;';
    var p = document.createElement('img');
    p.referrerPolicy = 'no-referrer';
    p.src = src; p.alt = alt || '';
    p.style.cssText = 'max-width:100%;max-height:100%;border-radius:var(--radius-md);box-shadow:0 12px 48px rgb(var(--c-shadow) / 0.55);';
    o.appendChild(p);
    function close(){ o.remove(); document.removeEventListener('keydown', k); }
    function k(e){ if (e.key === 'Escape') close(); }
    o.addEventListener('click', close);
    document.addEventListener('keydown', k);
    document.body.appendChild(o);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.jdgm-rev__pic-link, .jdgm-rev__pic-img');
    if (!link) return;
    var img = link.matches('img') ? link : link.querySelector('img');
    var src = (img && (img.currentSrc || img.src || img.getAttribute('data-src'))) || link.href;
    if (!src) return;
    e.preventDefault();
    e.stopPropagation();
    openLightbox(src, img ? img.alt : '');
  }, true);

  function start() {
    rescueImages();
    new MutationObserver(rescueImages).observe(document.body, { childList: true, subtree: true });
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
